import * as React from 'react';
import { FormControl, Select, MenuItem } from '@mui/material';
import { GridRenderEditCellParams } from '@mui/x-data-grid';
import { useQuery } from 'react-query';
import { apiClient } from '../../services/apiClient';
import { formatUnitOfMeasurement } from '../../utils/unitOfMeasurementFormatter';

// Mappatura tra tipo vettore energetico e categoria di unità di misura
const VECTOR_TYPE_TO_CATEGORY: Record<string, string> = {
  Electricity: 'Energia',
  NaturalGas: 'MassaVolume',
  Diesel: 'MassaVolume',
  Gasoline: 'MassaVolume',
  LPG: 'MassaVolume',
  Wood: 'MassaVolume',
  FuelOil: 'MassaVolume',
  DistrictHeating: 'Energia',
  Steam: 'Energia',
  Biogas: 'MassaVolume',
  Other: '', // Other può avere qualsiasi categoria
};

// Componente per il dropdown delle unità di misura con filtraggio per categoria basato sul vector_type
export const UnitOfMeasurementEditCell: React.FC<GridRenderEditCellParams> = ({
  id,
  value,
  field,
  api,
  row,
}) => {
  const vectorType = (row as any)?.vector_type as string | null | undefined;
  const category = vectorType ? VECTOR_TYPE_TO_CATEGORY[vectorType] : '';

  // Carica tutte le unità di misura disponibili
  const { data: allUnits = [] } = useQuery<string[]>('all-units-of-measure', () =>
    apiClient.get_all_units_of_measure_units_of_measure_all_get()
  );

  // Se c'è una categoria mappata per il vector_type, carica le unità di quella categoria
  const { data: categoryUnits = [] } = useQuery<string[]>(
    ['units-by-category', category],
    () => apiClient.get_units_by_category_units_of_measure_by_category__category__get(category),
    { enabled: !!category && category !== '' }
  );

  // Determina le opzioni da mostrare
  const options = React.useMemo(() => {
    if (category && category !== '' && categoryUnits.length > 0) {
      // Se c'è una categoria mappata per il vector_type, mostra solo quelle unità
      return categoryUnits;
    }
    // Altrimenti mostra tutte le unità disponibili
    return allUnits;
  }, [category, categoryUnits, allUnits]);

  const handleChange = (event: any) => {
    api.setEditCellValue({ id, field, value: event.target.value }, event);
  };

  return (
    <FormControl fullWidth size="small" sx={{ m: 1, minWidth: 120 }}>
      <Select value={value || ''} onChange={handleChange} autoFocus variant="standard">
        {options.map(unit => (
          <MenuItem key={unit} value={unit}>
            {formatUnitOfMeasurement(unit)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

